import { combineReducers } from 'redux';
import { REQUEST_FAQ, RECEIVE_FAQ, FAILURE_FAQ } from './constants';

/*
 * State shape
 {
    faqs: [],
    fetching: false,
    error: ''
 }
 */

const faqs = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_FAQ:
            return action.response.payload;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_FAQ:
            return true;
        case FAILURE_FAQ:
        case RECEIVE_FAQ:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_FAQ:
            return action.response.message;
        case REQUEST_FAQ:
        case RECEIVE_FAQ:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    faqs,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/faq/reducer.js